
document.addEventListener("DOMContentLoaded", () => {
    if (!customElements.get("main-video")) {
      customElements.define(
        "main-video",
        class HeroVideo extends HTMLElement {
          constructor() {
            super();
            this.isPaused = false;
            this.isPausedManually = false;
            this.video = this.querySelector("video");
            this.videoDeskSrc = this.video.getAttribute("data-src");
            this.videoMobileSrc = this.video.getAttribute("data-mobile-src");
            this.prevWidth = window.innerWidth;

            this.soundBtn = this.querySelector("[data-sound]");
            this.handleSound = this.handleSound.bind(this);
            this.soundBtn?.addEventListener("click", this.handleSound);

            this.playBtn = this.querySelector("[data-play-pause]");
            this.handlePlay = this.handlePlay.bind(this);
            this.playBtn?.addEventListener("click", this.handlePlay);

            this.changeVideoSource = this.changeVideoSource.bind(this);
            window.addEventListener("resize", () => {
              if (Math.abs(window.innerWidth - this.prevWidth) > 50) {
                this.changeVideoSource();
              }
            });

            this.changeVideoSource();
          }

          connectedCallback() {
            const handleIntersection = (entries, observer) => {
              try {
                if (!this.video) return;
                if (entries[0].isIntersecting) {
                  if (this.isPaused && !this.isPausedManually) {
                    this.playVideo();
                  }
                } else {
                  if (!this.isPaused && !this.isPausedManually) {
                    this.pauseVideo();
                  }
                }
              } catch (error) {
                console.log(error);
              }
            };

            new IntersectionObserver(handleIntersection.bind(this), {
              threshold: 0.15,
            }).observe(this.video);
          }

          handleSound() {
            if (this.video.muted) {
              this.video.muted = false;
              this.soundBtn.classList.remove("muted");
            } else {
              this.video.muted = true;
              this.soundBtn.classList.add("muted");
            }
          }
          playVideo() {
            this.video.play();
            this.playBtn.classList.add("playing");
            this.isPaused = false;
          }
          pauseVideo() {
            this.video.pause();
            this.playBtn.classList.remove("playing");
            this.isPaused = true;
          }
          handlePlay() {
            if (this.isPaused) {
              this.playVideo();
              this.isPausedManually = false;
            } else {
              this.pauseVideo();
              this.isPausedManually = true;
            }
          }

          changeVideoSource() {
            if (!this.video) return;

            const currentWidth = window.innerWidth;
            let newSrc;
            if (window.innerWidth >= 993 && this.videoDeskSrc) {
              newSrc = this.videoDeskSrc;
            } else if (window.innerWidth < 993 && this.videoMobileSrc) {
              newSrc = this.videoMobileSrc;
            } else {
              this.video.removeAttribute("src");
            }

            if (newSrc && newSrc !== this.video?.src) {
              this.video.src = newSrc;
              if (!this.isPaused) {
                this.playVideo();
              } else {
                this.pauseVideo();
              }
            }
            this.prevWidth = currentWidth;
          }
        }
      );
    }
  });